import React from "react";
import DashboardLayout from "../components/dashboard/DashboardLayout";
import AdminNavbar from "../components/navbar/AdminNavbar";

const AdminLayout = () => (
  <DashboardLayout layout="/admin" Navbar={AdminNavbar} />
);

export default AdminLayout;
